type ProcessEnv = {
    NODE_ENV: string;
    VERSION: string;
    PROFILE: string;
    FRONTEND_ANALYTICS?: string;
    FRONTEND_APPCUES?: string;
};
/**
 * @deprecated
 * Moving process.env to a different file for testing purposes.
 * Do not access this function directly, use the exported functions from env.ts instead.
 * Note that demo's process.env is production because we build demo and prod together. See webapp-nginx.dockerfile and package.json.
 */
const getProcessEnv = () => {
    // Can't return process.env directly because Webpack won't replace it during build time, though it works when using Vite.
    return {
        NODE_ENV: process.env.NODE_ENV,
        VERSION: process.env.VERSION,
        PROFILE: process.env.PROFILE,
        FRONTEND_ANALYTICS: process.env.FRONTEND_ANALYTICS,
        FRONTEND_APPCUES: process.env.FRONTEND_APPCUES
    } as ProcessEnv;
};
export default getProcessEnv;
